import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { CredentialStoreGenericType, CredentialStoreResourceType, } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CredentialStoresService = /** @class */ (function (_super) {
    tslib_1.__extends(CredentialStoresService, _super);
    function CredentialStoresService(http) {
        var _this = _super.call(this, http, MapperService.credentialStore) || this;
        _this._endpoint = '/odata/CredentialStores';
        return _this;
    }
    CredentialStoresService.prototype.getCredentialStoreTypes = function () {
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetAvailableCredentialStoreTypes()";
        return this._http.get(endpoint)
            .pipe(map(function (data) { return data.value.map(function (storeType) { return ({
            value: storeType,
            genericType: storeType === 'Database' ?
                CredentialStoreGenericType.Database :
                CredentialStoreGenericType.SecureStore,
        }); }); }));
    };
    CredentialStoresService.prototype.setDefaultStore = function (credentialStore, resourceType) {
        var endpoint = this._endpoint + "(" + credentialStore.id + ")/UiPath.Server.Configuration.OData.SetDefaultStoreForResourceType";
        var payload = { resourceType: CredentialStoreResourceType[resourceType] };
        return this._http.post(endpoint, JSON.stringify(payload));
    };
    CredentialStoresService.prototype.getDefaultStore = function (resourceType) {
        // tslint:disable-next-line: max-line-length
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetDefaultStoreForResourceType(resourceType='" + CredentialStoreResourceType[resourceType] + "')";
        return this._http.get(endpoint)
            .pipe(map(function (response) { return response.value; }));
    };
    CredentialStoresService.prototype.getResourcesForCredentialStore = function (credentialStore, resourceType, queryOptions) {
        var _this = this;
        // tslint:disable-next-line: max-line-length
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetResourcesForCredentialStoreTypes(key=" + credentialStore.id + ",resourceType='" + CredentialStoreResourceType[resourceType] + "')";
        return this._http.get("" + endpoint + this.getQueryString(queryOptions))
            .pipe(map(function (response) { return _this._mapData(response, MapperService.credentialTypeResource); }));
    };
    CredentialStoresService.prototype.deleteCredentialStore = function (credentialStore) {
        var endpoint = this._endpoint + "(" + credentialStore.id + ")/UiPath.Server.Configuration.OData.Delete";
        return this._http.post(endpoint, JSON.stringify({
            key: credentialStore.id,
            forceDelete: true,
        }));
    };
    CredentialStoresService.prototype.getSecureCredentialStoreConfiguration = function (name) {
        var _this = this;
        var endpoint = "/odata/Settings/UiPath.Server.Configuration.OData.GetSecureStoreConfiguration(storeTypeName='" + name + "')";
        return this._http.get(endpoint)
            .pipe(map(function (response) { return _this._mapData(response, MapperService.credentialStoreConfigurationEntryMap); }), map(function (response) { return response.data; }));
    };
    CredentialStoresService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CredentialStoresService_Factory() { return new CredentialStoresService(i0.ɵɵinject(i1.HttpClient)); }, token: CredentialStoresService, providedIn: "root" });
    return CredentialStoresService;
}(ODataService));
export { CredentialStoresService };
